import layoutHeaderAside from '@/layout'

import b_demo from './modules/backstage/demo'
import b_system from './modules/backstage/system'
import b_master from './modules/backstage/master'
import b_material from './modules/backstage/material'
import b_sample from './modules/backstage/sample'
import b_samplemanage from './modules/backstage/samplemanage'
import b_report    from './modules/backstage/report'
import b_appManager from './modules/backstage/appManager'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

/**
 * 在主框架内显示
 */
const frameIn = [
  {
    path: '/',
    component: layoutHeaderAside,
    children: [
      // 首页
      {
        path: '/',
        alias: '/admin',
        name: 'index',
        meta: {
          auth: true,
          funcID: 'B00',
          PID: 'B00',
          head: true,
          title: '首页'
        },
        component: _import('backstage')
      },
      {
        path: '/403',
        name: '403',
        meta:{
          title: '无权限访问'
        },
        component: _import('system/403')
      },
    ]
  },

  b_demo,
  b_system,
  b_master,
  b_material,
  b_sample,
  b_samplemanage,
  b_report,
  b_appManager

]

/**
 * 在主框架之外显示
 */
const frameOut = [
  // 登录
  {
    path: '/login',
    name: 'login',
    meta: {
      funcID: 'LOGIN'
    },
    component: _import('system/login')
  },
  // {
  //   path: '/403',
  //   name: '403',
  //   meta:{
  //     funcID: 'B00',
  //     PID: 'B00',
  //     title:'403'
  //   },
  //   component: _import('system/403')
  // },
]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
  ...frameIn,
  ...frameOut
  // ...errorPage
]
